import { gql } from "@apollo/client";
import {
  ApplicantModel,
  DocumentItem,
  FollowingQuestionsModel,
  HouseholdMemberModel,
  IFileUpload,
  SecurityQuestionsModel
} from "models";


export interface HouseholdMemberShort {
  caseAccessId: string;
  householdMemberId: string | null;
  name: string;
  documentsList: DocumentItem[];
}

export interface CASE_BY_ID_RESPONSE {
  caseById: {
    id: string
    mnsureEnrollment: Partial<{
      id: string;
      sameAnnualIncome: boolean;
      householdRelationships: string;
      applicant: ApplicantModel;
      householdMembers: HouseholdMemberModel[];
      followingQuestions: FollowingQuestionsModel[];
      sign: null;
      assister: null;
      securityQuestions: SecurityQuestionsModel;
    }>
    fileUploads: IFileUpload[]
  }
}


export interface CASE_BY_ID_SHORT_vars {
  caseAccessId: string;
}


export const CASE_BY_ID = gql`
  query caseById($caseAccessId: UUID!) {
    caseById(caseAccessId: $caseAccessId) {
      mnsureEnrollment {
        applicant {
          firstName
          lastName
        }
      }
    }
  }
`;
